/* eslint-disable prettier/prettier */
/** DO NOT EDIT - This file is auto-generated by running `yarn workspace lib-shared-feature-flags update` */
const defaultFeatureFlags = {
    "a-c-forward": false,
    "ada-chat-channel": false,
    "agent-copilot": false,
    "agent-copilot-improve-writing": false,
    "agent-copilot-improve-writing-custom-prompt": true,
    "agent-copilot-style-guides": false,
    "agent-copilot-trial-eligibility": false,
    "ai-translate-model-config-id": "",
    "allow-integration-api-token-usage": false,
    "analytics-business-hours": true,
    "automations": false,
    "call-noise-suppression": false,
    "chatbots-integration-settings": false,
    "collapse-tracking-card-core": false,
    "contact-custom-attribute": true,
    "conversation-assistant-for-dixa-messenger": false,
    "conversation-focus-mode": true,
    "conversation-message-delivery-status": true,
    "conversation-reverse-scroll": true,
    "conversation-summary": false,
    "csat-for-dixa-messenger": false,
    "csat-for-email": true,
    "csat-for-phone": true,
    "csat-for-phone-via-sms": true,
    "csat-for-widget-chat": false,
    "custom-analytics": true,
    "custom-cards": true,
    "custom-fields": true,
    "custom-roles": false,
    "dependant-custom-attribute": true,
    "desktop-app-notice-modal": true,
    "ecosystem-legacy-shopify-card-creation": false,
    "elevio-suggestions": false,
    "email-channel": true,
    "email-translation": false,
    "enable-call-recordings": true,
    "ewt-hide-strategy": false,
    "export-conversations": false,
    "facebook-messenger-channel": true,
    "has-bulk-operations": false,
    "has-chat-with-dixa-support": true,
    "has-custom-forms-feature": false,
    "has-messenger": true,
    "help-center": false,
    "high-limit-bulk-actions-core": false,
    "instagram-management": true,
    "integrations-for-dixa-messenger": false,
    "integrations-for-email": true,
    "integrations-for-phone": true,
    "knowledge-access": false,
    "knowledge-ai-draft": false,
    "knowledge-management-nav": false,
    "knowledge-suggestions": false,
    "knowledge-suggestions-language-switcher": true,
    "language-detection-dixa-messenger": true,
    "language-detection-email": true,
    "merge-contacts": true,
    "messenger-native-knowledge-integration": false,
    "mim-chatbot": false,
    "multilingual-knowledge": false,
    "new-live-dashboard": false,
    "organizations-sidebar": false,
    "partner-integrations-widget": true,
    "partner-integrations-widget-github": true,
    "partner-integrations-widget-jira": true,
    "partner-integrations-widget-klaviyo": true,
    "partner-integrations-widget-linear": true,
    "partner-integrations-widget-loyaltylion": false,
    "partner-integrations-widget-miuros": false,
    "partner-integrations-widget-sample": false,
    "partner-integrations-widget-shopify": true,
    "partner-integrations-widget-trustpilot": false,
    "partner-integrations-widget-voyado": true,
    "personal-settings-revamp": false,
    "phoenix-conversation": false,
    "phone-channel": true,
    "required-custom-attribute": true,
    "routing-audit-log-automations": false,
    "routing-use-canvas": true,
    "salesforce-integration": true,
    "scheduled-conversations": false,
    "ses-email-sending-enabled": false,
    "shadow-dom-messages": true,
    "show-tracking-card": true,
    "show-twilio-warn-notifications": false,
    "smart-article-create": false,
    "smart-reply-new-api": false,
    "sms-channel": false,
    "sms-compose": false,
    "spam-filtering": false,
    "subflows-in-dixa-messenger-flow-builder": false,
    "teams-assigning-teams-to-queues": false,
    "teams-setting-page-and-assigning-teams-to-queues": false,
    "templates-language-translation-control": false,
    "twitter-channel": false,
    "use-birdeatsbug": false,
    "use-enable-ios-and-android": false,
    "use-progressive-web-app": false,
    "use-shared-worker": true,
    "use-twilio-voice-sdk": true,
    "use-web-hid-busylight": true,
    "web-usb-jabra-integration": false,
    "webform-endpoints-integration": true,
    "whatsapp-channel": true,
    "widget-chat-channel": false,
    "write-html-email": true
};

export { defaultFeatureFlags as default, defaultFeatureFlags };
//# sourceMappingURL=featureFlags.es.js.map
